import { render } from "./index.vue?vue&type=template&id=f076e802"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f076e802&lang=scss"
script.render = render

export default script